import type { Route } from '#/global'
import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'
import pinia from '@/store'
import useSettingsStore from '@/store/modules/settings'
import generatedRoutes from 'virtual:generated-pages'
import { setupLayouts } from 'virtual:meta-layouts'

// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      whiteList: true,
      title: $t('app.route.login'),
    },
  },
  {
    path: '/onekey-login',
    name: 'OnekeyLogin',
    component: () => import('@/views/onekeyLogin.vue'),
    meta: {
      whiteList: true,
      title: '一键登录',
    },
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    },
  },
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: $t(useSettingsStore(pinia).settings.home.title),
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: $t('app.route.reload'),
          breadcrumb: false,
        },
      },
      {
        path: 'message-all',
        name: 'MessagesAll',
        component: () => import('@/layouts/components/Topbar/Toolbar/Notification/all.vue'),
        meta: {
          title: $t('app.route.allMessages'),
          breadcrumb: false,
        },
      },
      {
        path: 'message-detail',
        name: 'MessageDetail',
        component: () => import('@/layouts/components/Topbar/Toolbar/Notification/MessageDetail.vue'),
        meta: {
          title: '消息详情',
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/cloudresources',
    component: () => import('@/layouts/index.vue'),
    meta: {
      breadcrumb: false,
    },
    children: [
      {
        path: 'home',
        name: 'CloudResourcesHome',
        component: () => import('@/layouts/components/Topbar/Toolbar/CloudResources/cloud.component.vue'),
        meta: {
          title: $t('app.route.overview'),
          menu: false,
          breadcrumb: false,
        },
      },
      // {
      //   path: 'opensupplier',
      //   name: 'CloudResourcesOpenSupplier',
      //   component: () => import('@/layouts/components/Topbar/Toolbar/CloudResources/components/home.openSupplier.vue'),
      //   meta: {
      //     title: '开通云供应商',
      //     menu: false,
      //     breadcrumb: false,
      //   },
      // },
    ],
  },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  asyncRoutes,
  asyncRoutesByFilesystem,
  constantRoutes,
  constantRoutesByFilesystem,
  systemRoutes,
}
